<template>
  <div class="ftxq">
    <topNav :title="$t('fangTXQ_title')"
            url="/fangT"
            replace="true"></topNav>
    <div class="warp"
         v-if="orderInfo.fMasterDto">
      <div class="orderSta clearfix">
        <!--  预订单号:-->
        <div class="Num">{{ $t('fangTXQ_rsvNo') }}:
          <span>{{ orderInfo.fMasterDto.masterBase.rsvNo }}</span>
          <mt-badge type="success"
                    style="height:14px;line-height:14px"
                    v-if="orderInfo.fMasterDto.masterBase.rsvClass=='D' || orderInfo.fMasterDto.masterBase.rsvClass=='G'"
                    size="small">{{
              orderInfo.fMasterDto.masterBase.rsvClass == 'D' ? $t('fangTXQ_orderDisD') :
                $t('fangTXQ_orderDisG')
            }}
          </mt-badge>
        </div>
        <!--  状态:-->
        <div class="sta">{{ $t('fangTXQ_sta') }}:
          <span>{{ orderInfo.fMasterDto.masterBase.sta }}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <div class="hasChangeIcon" v-if="hasChangeRoom">换房</div>

          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!--  基础信息:-->
            {{ $t('fangTXQ_baseInfo') }}
          </div>
          <div class="spe-addGuest"
               @click="addGuest"
               v-if="(orderInfo.fMasterDto.masterBase.sta == 'R' || orderInfo.fMasterDto.masterBase.sta == 'I') && $hasPermission('mh!recpt!edit', orderInfo.rights.indexOf('recept!fit!ci') >= 0)">
            <i class="iconfont icon-jia"></i>
          </div>
          <ul class="infoContent twocol">
            <!--  姓名:-->
            <li class="p100">{{ $t('fangTXQ_name') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterGuest.name }}</span>
            </li>
            <!--  手机:-->
            <li class="p100">{{ $t('fangTXQ_mobile') }}:
              <span class="infoVal"> <a
                :href='"tel:"+orderInfo.fMasterDto.masterGuest.mobile'>{{ orderInfo.fMasterDto.masterGuest.mobile }}</a></span>
            </li>
            <!--  姓名2:-->
            <li class="p100" v-if="orderInfo.fMasterDto.masterGuest.name2">{{ $t('fangTXQ_name2') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterGuest.name2 }}</span>
            </li>
            <!--  姓/名:-->
            <li class="p100" v-if="orderInfo.fMasterDto.masterGuest.firstName">{{ $t('fangTXQ_firstName') }}:
              <span
                class="infoVal">{{
                  orderInfo.fMasterDto.masterGuest.firstName
                }} / {{ orderInfo.fMasterDto.masterGuest.lastName }}</span>
            </li>
            <!--  房类:-->
            <li @click="openChangeRoomTypeModal">{{ $t('fangTXQ_rmtype') }}:
              <span class="infoVal">
                {{ getRmType(orderInfo.fMasterDto.masterBase.rmtype) }}</span>
              <span class="iconfont icon-xia2" v-if="isJingJiang && !isThefClient"
                    style="position:relative;top: 2px;"></span>
            </li>
            <!--  房号:-->
            <li @click="openChangeRoomModal">{{ $t('fangTXQ_rmno') }}:
              <span class="infoVal"
                    style="color:red">{{ orderInfo.fMasterDto.masterBase.rmno }}</span>
              <span class="iconfont icon-xia2" style="position:relative;top: 2px;"></span>
            </li>
            <!--  抵店:-->
            <li class="p100">{{ $t('fangTXQ_arr') }}:
              <!--              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.arr | dateD}}</span>-->
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.arr }}</span>
            </li>
            <!--  离店:-->
            <li class="p100">{{ $t('fangTXQ_dep') }}:
              <!--              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.dep | dateD}}</span>-->
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.dep }}</span>
            </li>
            <!--  卡号:-->
            <li>{{ $t('fangTXQ_memberNo') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.memberNo }}</span>
            </li>
            <!--  证件类型:-->
            <li class="p100">{{ $t('fangTXQ_idCode') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterGuest.idCode }}</span>
            </li>
            <!--  证件号码:-->
            <li class="p100">{{ $t('fangTXQ_idNo') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterGuest.idNo }}

                 <i class="iconfont icon-credentials_icon"
                    @click="getJingJiangToken"
                    style="margin-left:0.5rem;color:#999;margin-top: 0.1rem;"
                    v-if="isJingJiang && $hasPermission('mh!recpt!edit', true)"></i>
                <template v-else>
                <i class="iconfont icon-saoma"
                   @click="sfzRe(orderInfo.fMasterDto)"
                   v-if="sfzR && $hasPermission('mh!recpt!edit', orderInfo.rights.indexOf('recept!fit!ci') >= 0)"
                   style="margin-left:0.5rem;color:#999"></i>
                  </template>
              </span>
            </li>
            <!--  协议公司:-->
            <li class="p100">{{ $t('fangTXQ_companyName') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.companyName }}</span>
            </li>
            <!--  旅行社:-->
            <li class="p100">{{ $t('fangTXQ_agentName') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.agentName }}</span>
            </li>
            <!--  订房中心:-->
            <li class="p100">{{ $t('fangTXQ_sourceName') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.sourceName }}</span>
            </li>
            <!--  订房中心:-->
            <li class="" v-if="orderInfo.fMasterDto.masterGuest.timesIn">{{ $t('fangTXQ_timesIn') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterGuest.timesIn }}</span>
            </li>
            <!--  订房中心:-->
            <li class="" v-if="orderInfo.pmsTimesIn">{{ $t('fangTXQ_pmsTimesIn') }}:
              <span class="infoVal">{{ orderInfo.pmsTimesIn }}</span>
            </li>
            <!--  房价码:-->
            <li style="clear:both">{{ $t('fangTXQ_ratecode') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.ratecode }}</span>
            </li>
            <!--  房价:-->
            <li>{{ $t('fangTXQ_realRate') }}:
              <span class="infoVal"
                    style="color:red">￥{{ orderInfo.fMasterDto.masterBase.realRate }}
                <span v-if="orderInfo.fMasterDto.masterBase.isSecretRate=='T'">保密</span>
              </span>
              <i class="mintui mintui-more"
                 @click="getEveryDateRate"></i>
            </li>

            <!--  电子签名:-->
            <li class="p100" v-if="fangTXQuseSign" style="display:flex;align-items: center">电子签名:
              <span class="infoVal">
                <signModal :masterId="orderInfo.fMasterDto.masterBase.rsvNo"></signModal>
              </span>
            </li>
          </ul>
        </div>

        <marketInfo :masterBase='orderInfo.fMasterDto.masterBase'></marketInfo>

        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('fangTXQ_other') }}
          </div>
          <ul class="infoContent">
            <li class="ha"> {{ $t('fangTXQ_amenities') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.amenities }}</span>
            </li>
            <li class="ha"> {{ $t('fangTXQ_specials') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.specials }}</span>
            </li>
            <li class="ha">{{ $t('fangTXQ_remark') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.remark }}
                <i class="iconfont icon-xiugai"
                   @click="updateRemark"
                   v-if="$hasPermission('mh!resrv!cmme!up',orderInfo.rights.indexOf('resrv!fit!edit') >= 0)"></i>
              </span>
            </li>
            <!-- 创建人 -->
            <li>{{ $t('fangTXQ_createUser') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.createUser }}</span>
            </li>
            <!-- 创建时间 -->
            <li>{{ $t('fangTXQ_createDatetime') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.createDatetime }}</span>
            </li>
            <!-- 修改人 -->
            <li>{{ $t('fangTXQ_modifyUser') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.modifyUser }}</span>
            </li>
            <!-- 修改时间 -->
            <li>{{ $t('fangTXQ_modifyDatetime') }}:
              <span class="infoVal">{{ orderInfo.fMasterDto.masterBase.modifyDatetime }}</span>
            </li>
          </ul>
        </div>

        <div class="info">
          <div class="infoTop">
            <span>
              <i class="iconfont icon-changfangxingbiaoqian"></i>
              <!-- 同住 -->
              {{ $t('fangTXQ_live_with') }}
            </span>
            <!--根据支付的版本展示同住人按钮-->
            <span class='addGuest'
                  v-if="(orderInfo.fMasterDto.masterBase.sta=='I' || orderInfo.fMasterDto.masterBase.sta=='R') && showPayBtn && $hasPermission('mh!recept!add', true)"
                  @click='goAddLiveWith'>
              <i class="iconfont icon-jia"></i>
            </span>
          </div>
          <div class="infoContent"
               style='border-bottom: none;'>
            <ul class="lf">
              <li v-for="val in orderInfo.fMasterDto.masterLiveList"
                  @click="goLinkRoom(val.masterBase.id)"
                  :key="val.masterBase.id">
                <template
                  v-if="val.masterGuest.name && (val.masterBase.sta=='I' || val.masterBase.sta=='R' || val.masterBase.sta=='O')">
                  {{ val.masterBase.rmno }} - {{ val.masterGuest.name }} <b>{{ val.masterBase.sta }}</b>
                </template>
              </li>
              <!-- 无 -->
              <li v-if="orderInfo.fMasterDto.masterLiveList.length == 0"
                  style="color:#ccc">{{ $t('fangTXQ_none') }}
              </li>
            </ul>
          </div>
        </div>

        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            <!-- 联房 -->
            {{ $t('fangTXQ_al_room') }}
          </div>
          <div class="infoContent"
               style='border-bottom: none;'>
            <ul class="lf">
              <li v-for="val in orderInfo.masterLinkListNew"
                  @click="goLinkRoom(val.id)"
                  :key="val.id">
                {{ val.rmno }} - {{ val.name }} <b>{{ val.sta }}</b>
              </li>
              <!-- 无 -->
              <li v-if="orderInfo.masterLinkListNew.length == 0"
                  style="color:#ccc">{{ $t('fangTXQ_none') }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <bill @goInsertBill="doCheckShift('goInsertBill')" :orderInfo='orderInfo'></bill>

      <div class="btnBottom ">
        <div class="staI "
             v-if="orderInfo.fMasterDto.masterBase.sta=='R'">
          <!-- 取消订单 -->
          <div class="btn"
               v-show="$hasPermission('mh!resrv!cancel', orderInfo.rights.indexOf('recept!fit!ci') >= 0)"
               @click="cancelOrder">{{ $t('fangTXQ_cancelOrder') }}
          </div>
          <!-- 办理入住 -->
          <div class="btn"
               v-show="$hasPermission('mh!resrv!checkin', orderInfo.rights.indexOf('recept!fit!ci') >= 0)"
               @click="checkIn">{{ $t('fangTXQ_checkIn') }}
          </div>
        </div>
        <div class="staR l_o_btm"
             v-if="orderInfo.fMasterDto.masterBase.sta=='I'">
          <!-- 加收全天 -->
          <div class="btn"
               @click="doCheckShift('addReceive1')"
               v-if="$hasPermission('mh!accnt!req', orderInfo.rights.indexOf('act!posting') >= 0)">
            {{ $t('fangTXQ_addReceive1') }}
          </div>
          <!-- 加收半天 -->
          <div class="btn"
               @click="doCheckShift('addReceive0')"
               v-if="$hasPermission('mh!accnt!req', orderInfo.rights.indexOf('act!posting') >= 0)">
            {{ $t('fangTXQ_addReceive0') }}
          </div>
          <!-- 挂账 -->
          <div class="btn"
               @click="doCheckShift('keepDebts')"
               v-if="$hasPermission('mh!rec!suspend', orderInfo.rights.indexOf('act!suspend') >= 0)">
            {{ $t('fangTXQ_keepDebts') }}
          </div>
          <!-- 退房 -->
          <div class="btn"
               @click="doCheckShift('goIncomeCheckout')"
               v-if="$hasPermission('mh!rec!checkout', orderInfo.rights.indexOf('act!checkout') >= 0)">
            {{ $t('fangTXQ_checkOut') }}
          </div>
        </div>
      </div>
    </div>

    <mt-palette-button content="+"
                       v-if="orderInfo.rights && orderInfo.fMasterDto.masterBase.sta=='I'"
                       direction="lt"
                       class="pb"
                       :radius="80"
                       ref="target_1"
                       mainButtonStyle="color:#fff;background-color:#f6a624;">
      <template v-if='isJingJiang'>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!scan!pay', orderInfo.rights.indexOf('act!posting') >= 0)"
             @click="doCheckShift('goScanPay')">
          <i class="iconfont iconfont icon-saoma"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!resrv!pay', orderInfo.rights.indexOf('act!posting') >= 0)"
             @click="doCheckShift('goIncomeAccount')"><i class="iconfont icon-JZQK"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup"
             @click="openJingJiangModal">
          <i class="iconfont icon-qiapian"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup"
             @click="openPrintSelectModal">
          <i class="iconfont icon-dayin"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!recept!exten', orderInfo.rights.indexOf('recept!delay') >= 0)"
             @click="showDelay"><i class="iconfont icon-xuzhu"></i>
        </div>
      </template>
      <template v-else>

        <div class="my-icon-button indexicon icon-popup"
            v-if="useQrcodePay"
             @click="showQrcodeModal" ><i class="iconfont icon-dingdan"></i></div>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!scan!pay', orderInfo.rights.indexOf('act!posting') >= 0) && showPayBtn"
             @click="doCheckShift('goScanPay')">
          <i class="iconfont iconfont icon-saoma"></i>
        </div>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!resrv!pay', orderInfo.rights.indexOf('act!posting') >= 0)"
             @click="doCheckShift('goIncomeAccount')"><i class="iconfont icon-JZQK"></i></div>
        <div class="my-icon-button indexicon icon-popup"
             v-if="$hasPermission('mh!recept!exten', orderInfo.rights.indexOf('recept!delay') >= 0)"
             @click="showDelay"><i class="iconfont icon-xuzhu"></i></div>
      </template>
    </mt-palette-button>

    <mt-palette-button content="+"
                       v-else-if='isJingJiang'
                       direction="lt"
                       class="pb"
                       :radius="80"
                       ref="target_1"
                       mainButtonStyle="color:#fff;background-color:#f6a624;">
      <div class="my-icon-button indexicon icon-popup"
           @click="openPrintSelectModal">
        <i class="iconfont icon-dayin"></i>
      </div>
      <!--      后两个display:none 用来修复mint ui组件的渲染bug-->
      <div class="my-icon-button indexicon icon-popup"
           style='display: none'>
        <i class="iconfont icon-dayin"></i>
      </div>
      <div class="my-icon-button indexicon icon-popup"
           style='display: none'>
        <i class="iconfont icon-dayin"></i>
      </div>
      <div class="my-icon-button indexicon icon-popup"
           style='display: none'>
        <i class="iconfont icon-dayin"></i>
      </div>
      <div class="my-icon-button indexicon icon-popup"
           style='display: none'>
        <i class="iconfont icon-dayin"></i>
      </div>
    </mt-palette-button>

    <delayIn ref="delay"
             @success="getrmInfo"></delayIn>

    <updateRemark ref="upRemark"
                  @success="getrmInfo"></updateRemark>

    <selectShift ref="selectShiftRef"
                 @success="setShift"></selectShift>

    <jingJiangModal ref="jingJiang"
                    @success="closeJingJiangModal"></jingJiangModal>


    <div v-if="popupEvalDay && (isJingJiang && !isThefClient)" @click="openEditPriceModal"
         style="z-index: 3002;height: 44px;line-height: 44px; position:fixed; bottom: 0; width: 100%;background: #fff;text-align: center;border-top: 1px solid #eaeaea;">
      修改房价
    </div>

    <mt-popup v-model="popupEvalDay"
              position="bottom"
              class="everyDatePop"
              :modal="true">
      <table v-if="isJingJiang"
             class="checkList"
             align='center'
             style="border-collapse:collapse;">
        <tbody>
        <tr>
          <!-- 日期 -->
          <th width="20%">{{ $t('fangTXQ_date') }}</th>
          <!-- 房价 -->
          <th width="30%">{{ $t('fangTXQ_rate') }}</th>
          <!-- 房间数 -->
          <th width="20%">{{ $t('fangTXQ_rmnum') }}</th>
          <th width="30%">优惠理由</th>
        </tr>
        </tbody>
        <tr>
          <!-- 合计 -->
          <td>{{ $t('fangTXQ_total') }}</td>
          <td>{{ sumRate(dateRate) }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="item in dateRate"
            :key="item.rsv_date">
          <td>{{ item.rsv_date | dateF }}</td>
          <td>
            <small>￥</small>
            {{ item.realShareRate }}
          </td>
          <td>{{ item.rmnum }}</td>
          <td>{{ getReasonDescript(item.dscResaon) }}</td>
        </tr>
      </table>

      <table v-else
             class="checkList"
             align='center'
             style="border-collapse:collapse;">
        <tbody>
        <tr>
          <!-- 日期 -->
          <th width="40%">{{ $t('fangTXQ_date') }}</th>
          <!-- 房价 -->
          <th width="30%">{{ $t('fangTXQ_rate') }}</th>
          <!-- 房间数 -->
          <th width="30%">{{ $t('fangTXQ_rmnum') }}</th>
        </tr>
        </tbody>
        <tr>
          <!-- 合计 -->
          <td>{{ $t('fangTXQ_total') }}</td>
          <td>{{ sumRate(dateRate) }}</td>
          <td></td>
        </tr>
        <tr v-for="item in dateRate"
            :key="item.rsv_date">
          <td>{{ item.rsv_date | dateF }}</td>
          <td>
            <small>￥</small>
            {{ item.realShareRate }}
          </td>
          <td>{{ item.rmnum }}</td>
        </tr>
      </table>
    </mt-popup>

    <!--orderInfo.fMasterDto.masterGuest.mobile-->

    <mt-popup v-model="guestPopVisible"
              v-if="updateGuest"
              class='guestInfo'
              popup-transition="popup-fade">
      <!-- 住客信息-->
      <h2> {{ $t('orderDetail_guest_info') }}</h2>

      <div class="guestSwiper">
        <!-- 房号：-->
        <p>{{ $t('fangTXQ_rmno') }}：
          <span class="formRoomNum"> {{ updateGuest.masterBase.rmno }}</span>
        </p>
        <div class="infoToWrite">
          <!-- 姓名 请输入姓名-->
          <mt-field :label="$t('fangTXQ_name')"
                    :placeholder="$t('orderDetail_guest_name_placeholder')"
                    v-model='updateGuest.masterGuest.name'></mt-field>
          <!-- 证件号码 请输入证件号码-->
          <mt-field :label="$t('fangTXQ_idNo')"
                    :placeholder="$t('fangTXQ_idNo_placeholder')"
                    v-model='updateGuest.masterGuest.idNo'></mt-field>
          <mt-field :label="$t('orderDetail_mobile')"
                    :placeholder="$t('orderDetail_mobile_placeholder')"
                    type="number"
                    v-model='updateGuest.masterGuest.mobile'></mt-field>
        </div>

      </div>

      <div class="btn">
        <!-- 取消-->
        <div class="unSure"
             @click="cancleGuestPop">{{ $t('cancel') }}
        </div>
        <!-- 确定-->
        <div class="sure"
             @click="changGuest">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>

    <div class='door-card-modal'
         v-if='doorCardModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>{{ $t('jj_door_card_info') }}</div>
        <div class='door-card-info'>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_room_no') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.roomNo }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_beginTime') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.beginTime }}</div>
          </div>
          <div class='info-item'>
            <div class='info-item-label'>{{ $t('jj_endTime') }}：</div>
            <div class='info-item-content'>{{ ResponseParameters.endTime }}</div>
          </div>
        </div>

        <div class='door-card-bottom'>
          <div class='door-btns'
               @click='closeDoorCardModal'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>

    <div class='print-select-modal'
         v-if='printSelectModalShow'>
      <div class='door-card-container'>
        <div class='door-card-title'>打印</div>
        <div class='modal-container'>
          <div class='spe-row'>
            <div class='btn-default'
                 @click='getListBillSceneLink("RECEPT")'>打印登记单
            </div>
            <div class='btn-default'
                 @click='getListDeposit'>打印定金单
            </div>
          </div>
          <div class='spe-row'>
            <div class='btn-default'
                 @click='getListBillSceneLink("FO_BILL")'>打印账单
            </div>
          </div>
        </div>
        <div class='door-card-bottom'>
          <div class='door-btns'
               @click='closePrintSelectModal'>{{ $t('cancel') }}
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="showPop"
              class='selectShift select-wrap'
              popup-transition="popup-fade">
      <!--班别选择-->
      <h2>押金记录</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="currentCode"
          :options="listDeposit">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="showPop=false">{{ $t('cancel') }}
        </div>
        <div class="sure"
             @click="save">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="showPop2"
              class='selectShift select-wrap'
              popup-transition="popup-fade">
      <h2>选择场景</h2>
      <div class='select-list-wrap'>
        <mt-radio
          v-model="currentCode2"
          :options="listBillSceneLink">
        </mt-radio>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="showPop2=false">{{ $t('cancel') }}
        </div>
        <div class="sure"
             @click="save2">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>

    <mt-popup v-model="showPopRoom"
              class='selectShift select-wrap'
              style="width: 96%;z-index: 3000"
              popup-transition="popup-fade">
      <!--      <h2>选择换房房间</h2>-->
      <h2>{{ $t('fangTXQ_changeRoomTitle') }}</h2>
      <div class='room-list-wrap'>
        <div class="room-item"
             :class="{'active': (item.id == currentSelectRoomItem.id)}"
             @click="chooseChangeRoom(item)" v-for="(item,index) in roomList" :key="index">
          {{ item.code }}
          <!--          <span class="type-icon">{{item.rmtype}}</span>-->
        </div>
      </div>

      <div class='room-list-wrap' v-if="!isJingJiang">
        <div class="title" style="padding-bottom: 10px;font-size: 15px;">换房理由</div>
        <div class="room-item"
             :class="{'active': (item.code == chooseRmchgReasonItem.code)}"
             @click="chooseChangeReason(item)" v-for="(item,index) in rmchgReasonList" :key="index">
          {{ item.descript }}
        </div>
      </div>

      <div class="btn">
        <div class="unSure"
             @click="closeChangeRoom">{{ $t('cancel') }}
        </div>
        <div class="sure"
             @click="confirmChangeRoom">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>

    <mt-popup v-model="showPopRoomType"
              class='selectShift select-wrap'
              style="width: 96%;z-index: 2000"
              popup-transition="popup-fade">
      <!--      <h2>选择换房房间</h2>-->
      <h2>请选择换房房型</h2>
      <div class='room-list-wrap'>
        <div class="room-item"
             style="text-align: left"
             :class="{'active': (
               (currentSelectRoomTypeItem.rmtype && (item.rmtype == currentSelectRoomTypeItem.rmtype)) ||
               (currentSelectRoomTypeItem.code && (item.code ==  currentSelectRoomTypeItem.code)))}"
             @click="chooseChangeRoomType(item)" v-for="(item,index) in roomTypeList" :key="index">
          <!--          {{item.descript}} -->
          <template v-if="isJingJiang">
            <span class="rmtype-font">{{ item.rmtype }}</span> ({{ item.rate1 }}元)
          </template>
          <span class="rmtype-font" v-else>{{ item.name }}</span>
        </div>
      </div>
      <div class="btn">
        <div class="unSure"
             @click="closeChangeRoomType">{{ $t('cancel') }}
        </div>
        <div class="sure"
             @click="confirmChangeRoomType">{{ $t('determine') }}
        </div>
      </div>
    </mt-popup>


    <div class='edit-price-modal'
         v-if='showEditPriceModal'>
      <div class='edit-price-modal-container'>
        <div class='edit-price-title'>
          修改房价
          <i class='iconfont icon-cuowu'
             @click='closeEditPrice'></i>
        </div>
        <div class='edit-top-nav'>
          <span class='edit-top-item edit-date'>{{ $t('fangTXQ_date') }}</span>
          <span class='edit-top-item origin-price'>协议价</span>
          <span class='edit-top-item edit-price'>{{ $t('fangTXQ_rate') }}</span>
          <span class='edit-top-item edit-reason'>{{ $t('book_reason') }}</span>
        </div>
        <div class='edit-price-body'>
          <div class='edit-price-item'
               :class='{active: currentLi == index}'
               @click='setCurrentLi(index)'
               v-for='(item, index) in currentRsvRates'
               :key='"everyDayRate" + item.rsv_date'>
            <span class='edit-date'
                  :class='{firday:new Date(item.rsv_date).getDay()== 6 || new Date(item.rsv_date).getDay()== 0}'
                  style='text-align: center;'>
              {{ item.rsv_date | dateMD }}
              <br>
              {{ item.rsv_date | week }}
            </span>
            <span class='origin-price'
                  style='text-align: center;'>{{ item.realPrice }}</span>
            <!-- 房费-->
            <div class='edit-price'>
              <span>￥
                <input type='number'
                       :disabled='!item.dscResaon'
                       class='spe-input'
                       v-model='item.realRate'>
                <!--                *{{ currentRmNum }}-->
              </span>
            </div>

            <div class='edit-reason'>
              <select v-model="item.dscResaon"
                      class="options"
                      style="width: 98%">
                <option v-for="(item2,index2) in reasonList"
                        :value="item2.code"
                        :key="index2">{{ item2.descript }}({{ item2.disc1 * 100 }}%)
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class='edit-price-footer'>
          <div class='edit-price-btn price-cancel-btn'
               @click='syncPrice'>{{ $t('book_sync') }}
          </div>
          <div class='edit-price-btn'
               @click='confirmEditPrice'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>

    <form-qr-code-modal ref="formQrCodeModal" @emitFormQrCode="emitFormQrCode"></form-qr-code-modal>
    <qrcode-modal ref="qrCodeModal"></qrcode-modal>
  </div>
</template>

<script>
import jingJiangModal from './fangTXQ-comp/jingJiangModal';
import signModal from './fangTXQ-comp/signModal';
import delayIn from './fangTXQ-comp/delayIn';
import formQrCodeModal from './fangTXQ-comp/formQrCodeModal';
import qrcodeModal from './fangTXQ-comp/qrcodeModal';
import {MessageBox} from 'mint-ui';
import updateRemark from './fangTXQ-comp/updateRemark';
import selectShift from '../../common/selectShift';
import bill from './fangTXQ-comp/bill';
import marketInfo from './fangTXQ-comp/marketInfo';
import _ from 'lodash';
import moment from 'moment';
import json from "../../../conf/datePick";

export default {
  data() {
    return {
      orderInfo: {},
      checkOutInfo: {},
      dateRate: [],
      popupEvalDay: false,
      sfzR: null,
      currentShift: {}, // 当前的班次
      actionType: '', // 操作类型

      showPayBtn: false,

      guestPopVisible: false,
      updateGuest: null,

      // 锦江刷身份证
      isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      jingJiangToken: '',
      chainNo: '',
      Key: '',
      secretKey: '',
      doorCardModalShow: false,
      ResponseParameters: {
        roomNo: '',
        beginTime: '',
        endTime: '',
      },
      tempRoomNo: '',
      listened: false,

      //锦江打印
      printSelectModalShow: false,
      listDeposit: [],
      listBillSceneLink: [],
      showPop: false,
      showPop2: false,
      currentCode: '',
      currentCode2: '',
      accnt: '',
      sceneCode: '',

      // 换房
      showPopRoom: false,
      roomList: [],
      currentSelectRoomItem: {},

      // 换房类房号
      hasChangeRoom: false,
      showPopRoomType: false,
      roomTypeList: [],
      currentSelectRoomTypeItem: {},
      isRmType: false,

      // 普通版本换房
      rmchgReasonList: [],
      chooseRmchgReasonItem: {},
      // 修改房价
      currentRsvRates: [],
      reasonList: [],
      currentItem: {}, // 当前编辑的房型节点
      showEditPriceModal: false,
      currentLi: {},

      // 判断是否为锦江商务版
      isThefClient: localStorage.getItem('isThefClient') == 'yes',

      // 启用电子签名
      fangTXQuseSign: localStorage.getItem('fangTXQuseSign') == 'T',
      // 判断是否显示生成二维码支付功能
      useQrcodePay: localStorage.getItem('useQrcodePay') == 'yes',
    };
  },
  mounted() {
    this.getrmInfo();
    this.getLocalShift()
    this.initJingJiangListen()
    if (this.isJingJiang) {
      this.getReasonList()
    } else {
      this.getetRmchgReason()
    }
  },
  methods: {
    getetRmchgReason(){
      this.$http
        .post('/mobilepmsapi/reception/getRmchgReason',{
          noErrorToast: true
        })
        .then(res => {
          if (res.data.result == 0) {
            this.rmchgReasonList = res.data.retVal || []
          } else {
            // this.msg2(res.data.msg);
          }
        });
    },
    setCurrentLi(index) {
      this.currentLi = index
    },

    dateX(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
    },

    getReasonDescript(code) {
      var reasonList = this.reasonList || []
      var temp = ''
      reasonList.map((item, index) => {
        if (item.code == code) {
          temp = item.descript
        }
      })
      return temp
    },
    openEditPriceModal() {
      let temp = JSON.parse(JSON.stringify(this.dateRate || []))
      let currentRsvRates = temp.filter((item) => {
        return moment(item.rsv_date).diff(moment(), 'days') > -1
      })
      currentRsvRates.map((item, index) => {
        item.realRate = item.realShareRate || '' // item.privce
      })
      if (currentRsvRates.length) {
        this.currentRsvRates = currentRsvRates
        this.popupEvalDay = false
        this.showEditPriceModal = true
        this.$forceUpdate()
      } else {
        this.msg2('只能修改今天以及今天之后的房价')
      }
    },

    syncPrice() {
      let currentRsvRates = this.currentRsvRates || []
      let temp2 = currentRsvRates[this.currentLi]
      let tempReason = temp2.dscResaon
      let tempPrice = temp2.realRate
      currentRsvRates.map((item, index) => {
        item.dscResaon = tempReason
        item.realRate = tempPrice
      })
      this.currentRsvRates = currentRsvRates
      this.$forceUpdate()
    },

    closeEditPrice() {
      this.currentRsvRates = []
      this.$forceUpdate()
      this.showEditPriceModal = false
    },
    confirmEditPrice() {
      let temp = JSON.parse(JSON.stringify(this.currentRsvRates || []))
      var flag = true
      var msg = ''
      temp.map((item, index) => {
        item.date = this.dateX(item.rsv_date)
        var dscResaon = item.dscResaon
        var reason = this.getReason(dscResaon)
        var disc1 = reason.disc1
        var minPrice = item.realPrice * (1 - disc1)

        if (item.realRate !== '') {
          if (Number(item.realRate) < minPrice) {
            msg = item.date + ' \n ' + reason.descript + '的多可以优惠' + (disc1 * 100) + '%,最低优惠价格为' + parseFloat(minPrice).toFixed(2) + ', 请调整房价或优惠理由'
            flag = false
          } else {
            item.realRate = Number(item.realRate)
          }
        }
      })

      if (flag) {
        this.showEditPriceModal = false
        this.changeRoomPrice()
      } else {
        this.msg2(msg)
      }
    },

    getReason(reason) {
      var reasonList = this.reasonList || []
      var temp = {}
      reasonList.map((item) => {
        if (reason == item.code) {
          temp = item
        }
      })
      return temp
    },

    getReasonList() {
      this.$http
        .post('/mobilepmsapi/reception/listCodeReason')
        .then(res => {
          if (res.data.result == 0) {
            this.reasonList = res.data.retVal.resultInfo || []
          } else {
            this.msg2(res.data.msg);
          }
        });
    },

    // 修改房价
    changeRoomPrice() {
      var self = this
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      var arr = this.currentRsvRates

      var newArr = []
      arr.map((item, index) => {
        var tempItem = {}
        tempItem.rsvDate = item.rsv_date
        tempItem.realRate = item.realRate
        tempItem.dscReason = item.dscResaon
        newArr.push(tempItem)
      })
      this.$http.post('/mobilepmsapi/reception/saveRsvRateListForMihotel', {
        accnt: masterBase.id,
        rsvrateJson: JSON.stringify(newArr)
      }).then(res => {
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          self.hasChangeRoom = retVal.resultMsg == "换过房"
          self.msg2('房价修改成功')
        } else {
          self.msg2(res.data.msg)
        }
      });
    },

    getIfChangeRoom() {
      var self = this
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      this.hasChangeRoom = false
      this.$http.post('/mobilepmsapi/reception/findRoomchgTipsForMihotel', {
        accnt: masterBase.id,
        noErrorToast: true
      }).then(res => {
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          this.hasChangeRoom = retVal.resultMsg == "换过房"
        } else {
          // self.msg2(res.data.msg)
        }
      });
    },

    // 标准版本换房
    openChangeRTNormal(){
      var self = this
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      self.roomTypeList = []
      self.currentSelectRoomItem = {}
      self.currentSelectRoomTypeItem = {}
      self.isRmType = false
      self.showPopRoomType = false

      this.$http.post('/mobilepmsapi/reception/bookInitForRmtype', {
        arr: moment(masterBase.arr).format(
          'YYYY-MM-DD'
        ),
        dep: moment(masterBase.dep).format(
          'YYYY-MM-DD'
        ),
        rmnum: 1
      }).then(res => {
        if (res.data.result == 0) {
          var data = res.data.retVal || {}
          var rateQueryList = data.rmtype || []
          if (rateQueryList.length > 0) {
            self.roomTypeList = rateQueryList || []
            self.showPopRoomType = true
          } else {
            self.msg2('没有查询到可换房型')
          }
        } else {
          this.msg(res.data.msg);
        }
      });
    },

    openChangeRoomTypeModal() {
      var self = this
      if (!(this.isJingJiang && !this.isThefClient)) {
        // this.openChangeRTNormal()
        return
      }
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      self.roomTypeList = []
      self.currentSelectRoomItem = {}
      self.currentSelectRoomTypeItem = {}
      self.isRmType = false
      self.showPopRoomType = false
      this.$http.post('/mobilepmsapi/reception/rateQuerypForMihotel', {
        accnt: masterBase.id,
        taCode: masterBase.ratecode,
      }).then(res => {
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          var resultInfo = retVal.resultInfo || {}
          var rateQueryList = resultInfo.rateQueryList || []
          if (rateQueryList.length > 0) {
            self.roomTypeList = rateQueryList || []
            self.showPopRoomType = true
          } else {
            self.msg2('没有查询到可换房型')
          }
        } else {
          self.msg2(res.data.msg)
        }
      });
    },

    updateNewTypeRoom(isRoomNoOnly) {
      var self = this
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      var currentSelectRoomTypeItem = this.currentSelectRoomTypeItem || {}
      var item = this.currentSelectRoomItem || {}

      var url = ''
      var param = {}
      if(this.isJingJiang){
         url = '/mobilepmsapi/reception/updateMasterForMihotel'
         param = {
           accnt: masterBase.id,
           realRate: currentSelectRoomTypeItem.rate1,
           rmtype: currentSelectRoomTypeItem.rmtype,
           rmno: item.code,
         }
      } else {
         url = '/mobilepmsapi/reception/updateMaster'
         var roomType= currentSelectRoomTypeItem.code || ''
        if(isRoomNoOnly == 'isRoomNoOnly'){
          var orderInfo = this.orderInfo || {}
          var fMasterDto = orderInfo.fMasterDto || {}
          var masterBase = fMasterDto.masterBase || {}
          roomType = masterBase.rmtype
        }
         param = {
           accnt: masterBase.id,
           rate: '',
           roomType: currentSelectRoomTypeItem.code,
           roomNo: item.code,
           upReason: this.chooseRmchgReasonItem.code,
         }
      }

      this.$http.post(url, param).then(res => {
        if (res.data.result == 0) {
          self.msg2('换房成功')
          self.closeChangeRoom()
          self.closeChangeRoomType()
          self.getrmInfoById(masterBase.id);
          // 重置
          self.currentSelectRoomTypeItem = {}
          self.item = {}
          self.isRmType = false
        } else {
          self.msg2(res.data.msg)
        }
      });
    },

    chooseChangeRoomType(item) {
      this.currentSelectRoomTypeItem = item
    },

    confirmChangeRoomType() {
      this.isRmType = true
      var currentSelectRoomTypeItem = this.currentSelectRoomTypeItem || {}
      if (currentSelectRoomTypeItem.rmtype || currentSelectRoomTypeItem.code) {
        this.openChangeRoomModal('yes')
      } else {
        this.msg2('请选择房型')
      }
    },

    closeChangeRoomType() {
      this.currentSelectRoomTypeItem = []
      this.showPopRoomType = false
      this.isRmType = false
    },

    openChangeRoomModalNomarl(isRmtype){
      var self = this
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      var rmtype = masterBase.rmtype
      if (isRmtype == 'yes') {
        rmtype = this.currentSelectRoomTypeItem.code
      } else {
        this.isRmType = false
      }
      this.$http.post('/mobilepmsapi/reception/findRoomNosByDateAndRmtype', {
        rmtype: rmtype,
        arrDate: masterBase.arr,
        depDate: masterBase.dep,
        noErrorToast: true
      }).then(res => {
        if (res.data.result == 0) {
          self.roomList = res.data.retVal || []
          if (self.roomList.length > 0) {
            self.showPopRoom = true
            self.chooseRmchgReasonItem = this.rmchgReasonList[0] || {}
          } else {
            // self.msg2('没有查询到可以更换的房间')
            self.msg2(self.$t('fangTXQ_changeRoomNoRoom'))
          }
        } else {
          // self.msg2(res.data.msg)
        }
      });
    },
    openChangeRoomModal(isRmtype) {
      const self = this
      if (!this.isJingJiang) {
        this.openChangeRoomModalNomarl(isRmtype)
        return
      }
      var orderInfo = this.orderInfo || {}
      var fMasterDto = orderInfo.fMasterDto || {}
      var masterBase = fMasterDto.masterBase || {}
      var rmtype = masterBase.rmtype
      if (isRmtype == 'yes') {
        rmtype = this.currentSelectRoomTypeItem.rmtype
      } else {
        this.isRmType = false
      }
      this.$http.post('/mobilepmsapi/reception/getChangeRoomRmno', {
        rmtype: rmtype,
        arr: moment(masterBase.arr).format(
          'YYYY-MM-DD'
        ),
        dep: moment(masterBase.dep).format(
          'YYYY-MM-DD'
        ),
      }).then(res => {
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          self.roomList = retVal.result || []
          if (self.roomList.length > 0) {
            self.showPopRoom = true
          } else {
            // self.msg2('没有查询到可以更换的房间')
            self.msg2(self.$t('fangTXQ_changeRoomNoRoom'))
          }
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    chooseChangeRoom(item) {
      this.currentSelectRoomItem = item
    },
    closeChangeRoom() {
      this.currentSelectRoomItem = []
      this.showPopRoom = false
    },

    chooseChangeReason(item){
      this.chooseRmchgReasonItem = item
    },
    confirmChangeRoom() {
      var item = this.currentSelectRoomItem || {}
      if (!item.code) {
        this.msg2('请选择房间号')
        return
      }
      if (this.isRmType) {
        this.updateNewTypeRoom()
      } else {
        if(this.isJingJiang){
          const self = this
          var orderInfo = this.orderInfo || {}
          var fMasterDto = orderInfo.fMasterDto || {}
          var masterBase = fMasterDto.masterBase || {}
          this.$http.post('/mobilepmsapi/reception/changeRoomRmno', {
            masterId: masterBase.id,
            rmno: item.code,
            realRate: masterBase.realRate,
          }).then(res => {
            if (res.data.result == 0) {
              // self.msg2('换房成功')
              self.msg2(self.$t('fangTXQ_changeRoomSuccess'))
              self.closeChangeRoom()
              self.getrmInfoById(masterBase.id);
            } else {
              self.msg2(res.data.msg)
            }
          });
        } else {
          this.updateNewTypeRoom('isRoomNoOnly')
        }
      }
    },
    save() {
      this.getDepositBillPdf(this.currentCode)
      this.showPop = false
    },
    save2() {
      if (this.sceneCode == 'RECEPT') {
        this.getOrderBillPdf(this.currentCode2)
      } else {
        this.getConsumptionBillPdf(this.currentCode2)
      }
      this.showPop2 = false
    },
    // 登记单
    getOrderBillPdf(billCode) {
      const self = this
      this.$http.post('/mobilepmsapi/print/getOrderBillPdf', {
        hotelCode: localStorage.getItem('hotelCode'),
        hotelGroupId: localStorage.getItem('hotelGroupId'),
        hotelId: localStorage.getItem('hotelId'),
        billCode: billCode,
        accnt: this.orderInfo.fMasterDto.masterBase.id,
      }).then(res => {
        if (res.data.result == 0) {
          self.downloadPdf(res.data.retVal)
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    getConsumptionBillPdf(billCode) {
      const self = this
      this.$http.post('/mobilepmsapi/print/getConsumptionBillPdf', {
        hotelCode: localStorage.getItem('hotelCode'),
        hotelGroupId: localStorage.getItem('hotelGroupId'),
        hotelId: localStorage.getItem('hotelId'),
        billCode: billCode,
        accnt: this.orderInfo.fMasterDto.masterBase.id,
      }).then(res => {
        if (res.data.result == 0) {
          self.downloadPdf(res.data.retVal)
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    // 打印预订单
    getDepositBillPdf(billDataId) {
      const self = this
      this.$http.post('/mobilepmsapi/print/getDepositBillPdf', {
        hotelCode: localStorage.getItem('hotelCode'),
        hotelGroupId: localStorage.getItem('hotelGroupId'),
        hotelId: localStorage.getItem('hotelId'),
        billDataId: billDataId,
        accnt: this.orderInfo.fMasterDto.masterBase.id,
      }).then(res => {
        if (res.data.result == 0) {
          self.downloadPdf(res.data.retVal)
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    getListDeposit() {
      const self = this
      self.listDeposit = []
      this.$http.post(`/mobilepmsapi/print/listDeposit`, {
        accnt: this.orderInfo.fMasterDto.masterBase.id  // 0 或者 3267, 取登记单的 id
      }).then(res => {
        if (res.data.result == 0) {
          let arr = res.data.retVal || []
          if (arr.length > 0) {
            arr.map((item, index) => {
              // 为了使用 mint ui的 radio，格式改一下
              item.label = item.taDescript + ' - ' + item.pay + '元'
              item.value = (item.id + '') || ''
              self.listDeposit.push(item)
            })
            this.showPop = true
          } else {
            self.msg2('没有查询到押金记录')
          }
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    getListBillSceneLink(sceneCode) {
      const self = this
      self.sceneCode = sceneCode
      self.listBillSceneLink = []
      this.$http.post(`/mobilepmsapi/print/listBillSceneLink`, {
        sceneCode: sceneCode, // 'FO_BILL' || 'RECEPT'
      }).then(res => {
        if (res.data.result == 0) {
          let arr = res.data.retVal || []
          if (arr.length > 0) {
            arr.map((item, index) => {
              // 为了使用 mint ui的 radio，格式改一下
              item.label = item.code + ' - ' + item.descript
              item.value = (item.code + '') || ''
              self.listBillSceneLink.push(item)
            })
            this.showPop2 = true
          } else {
            // self.msg2('没有查询到押金记录')
          }
        } else {
          self.msg2(res.data.msg)
        }
      });
    },
    openPrintSelectModal() {
      this.printSelectModalShow = true
    },
    closePrintSelectModal() {
      this.printSelectModalShow = false
    },
    initJingJiangListen() {
      let that = this
      if (this.isJingJiang && !this.listened) {
        this.listened = true
        document.addEventListener('resume', function () {
          that.closeDoorCardModal()
          let arg = plus.runtime.arguments || ''
          let lastInvokeId = localStorage.getItem('lastInvokeId') || ''
          // alert('fangTXQ被唤醒，参数是：' + arg + ', listened' + that.listened + ',' + that.$route.name + ',' + lastInvokeId)
          //从后台切换到前台
          if (arg != '' && that.$route.name == 'fangTXQ') {
            try {
              let temp = arg.split('//') || []
              let str = temp[1] || ''
              // plus.runtime.arguments = ''
              if (str) {
                let aj = that.parseQueryString(str)
                let roomNo = aj.roomNo || ''
                // alert('fangTXQ lastInvokeId: ' + lastInvokeId + ', ajId: ' + aj.id)
                if (lastInvokeId && lastInvokeId == aj.id) {
                  // that.msg2('重复读卡')
                } else {
                  setTimeout(() => {
                    localStorage.setItem('lastInvokeId', aj.id)
                  }, 500)
                  if (roomNo) {
                    if (roomNo == '0') {
                      that.msg2(that.$t('jj_empty_card'))
                    } else {
                      that.doorCardModalShow = true
                      that.tempRoomNo = roomNo
                      that.ResponseParameters = aj || {}
                    }
                  } else {
                    // that.msg2(that.$t('jj_empty_card'))
                  }
                }
              }
              // 处理JSON对象aj
            } catch (e) {
              // 若传入的参数不是JSON格式字符，需处理异常情况
            }
          }
        }, false);
      }
    },
    closeDoorCardModal() {
      this.tempRoomNo = ''
      this.ResponseParameters = {
        roomNo: '',
        beginTime: '',
        endTime: '',
      }
      this.doorCardModalShow = false
    },
    // 锦江读身份证
    jingjiangShuaka() {
      const self = this
      let obj = {
        'Key': this.Key,
        'Token': this.jingJiangToken,
        'Category': '1', // 1身份证 2身份证解码信息
        'EventName': 'Read',
        'CardType': 'IDCard',
        'isJingJiangLocal': true
      }
      this.wakeUpJingJiangApp('readIdCard')
      this.$http.post('/CardService/RequestForWrite', obj).then(res => {
        // alert('读取身份证返回结果：' + JSON.stringify(res, null, 4))
        if (res.data.result == 0) {
          self.msg2(self.$t('jj_id_card_read_success'))
          let guest = self.orderInfo.fMasterDto || {}
          let guestinfo = [];
          var retVal = res.data.retVal || {}
          let so = JSON.parse(retVal.ResponseParameters || "{}") || {}
          guestinfo.push({
            id: guest.masterBase.id,
            name: so.name,
            idNo: so.idnum,
            idCode: '01',
            address: so.address,
            sex: so.sex,
            birthday: so.birthDate,
            national: so.nation
          });
          console.log(guestinfo);
          self.$http
            .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
            .then(res => {
              if (res.data.result == 0) {
                guest.masterGuest.name = so.name;
                guest.masterGuest.idNo = so.idnum;
                self.msg2(self.$t('msg_update_success'));
              } else {
                self.msg2(res.data.msg);
              }
            });
        } else {
          MessageBox.alert(res.data.msg)
        }
      });
    },
    getJingJiangToken() {
      let objStr = localStorage.getItem('JingJiangSetting') || '{}'
      let obj = JSON.parse(objStr)
      this.chainNo = obj.HotelId || ''
      this.Key = obj.Key || ''
      obj.isJingJiangLocal = true
      this.$http.post('/CardService/Authorize', obj).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {}
          this.jingJiangToken = retVal.Token || '';
          this.jingjiangShuaka()
        } else {
          this.msg2(this.$t('jj_token_error'));
        }
      });
    },

    // 锦江门卡操作
    openJingJiangModal() {
      this.sub_log()
      let dto = this.orderInfo.fMasterDto || {}
      this.$refs.jingJiang.show(dto.masterBase || {});
    },
    closeJingJiangModal() {

    },
    /*添加入住人信息*/
    addGuest() {
      this.updateGuest = _.cloneDeep(this.orderInfo.fMasterDto);
      this.guestPopVisible = true;
    },
    /*改变入住人信息*/
    changGuest() {
      this.guestPopVisible = false;
      let guestinfo = [];

      guestinfo.push({
        id: this.updateGuest.masterBase.id,
        name: this.updateGuest.masterGuest.name,
        idNo: this.updateGuest.masterGuest.idNo,
        mobile: this.updateGuest.masterGuest.mobile
      });
      // console.log(guestinfo);
      this.$http
        .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
        .then(res => {
          if (res.data.result == 0) {
            //修改成功
            this.msg2(this.$t('msg_modify_success'));
            this.cancleGuestPop();
          } else {
            this.msg2(res.data.msg);
            this.guestPopVisible = true;
          }
        });
    },
    /*关闭入住人信息弹框*/
    cancleGuestPop() {
      this.guestPopVisible = false;
      this.getrmInfo();
    },

    formatUrlParam() {
      var m = this.orderInfo.fMasterDto;
      return '?id=' + m.masterBase.id +
        '&rmno=' +
        m.masterBase.rmno +
        '&name=' +
        m.masterGuest.name +
        '&redirect=' +
        encodeURIComponent('/fangTXQ?id=' + m.masterBase.id)
    },
    goIncomeAccount() {
      this.sub_log();
      this.$router.push('/ftxq/IncomeAccount' + this.formatUrlParam());
    },
    goInsertBill() {
      this.sub_log();
      this.$router.push('/ftxq/InsertBill' + this.formatUrlParam());
    },

    goScanPay() {
      this.sub_log();
      this.$router.push('/ftxq/scanPay' + this.formatUrlParam());
    },

    goAddLiveWith() {
      let orderInfo = this.orderInfo || {}
      let rights = orderInfo.rights || []
      let hasSfzRight = (rights.indexOf('recept!fit!ci') >= 0) ? 'yes' : 'no'
      this.$router.push('/ftxq/addLiveWith' + this.formatUrlParam() + '&hasSfzRight=' + hasSfzRight + '&sfzR=' + encodeURIComponent(this.sfzR));
    },

    // 判断班别是否存在
    doCheckShift(actionType = '') {
      this.actionType = actionType
      let currentShift = this.currentShift || {}
      if (currentShift.code) {
        this.doNext()
      } else {
        this.openSelectShift()
      }
    },

    getLocalShift() {
      let localShift = localStorage.getItem('currentShift') || '';
      this.currentShift = localShift ? JSON.parse(localShift) : {}
    },

    openSelectShift() {
      let currentShift = this.currentShift || {}
      this.$refs.selectShiftRef.show(currentShift.code);
    },

    setShift(shiftItem = {}) {
      localStorage.setItem('currentShift', JSON.stringify(shiftItem));
      this.currentShift = shiftItem || {};
      this.doNext()
    },

    doNext() {
      let actionType = this.actionType || ''

      if (actionType === 'addReceive1') {
        this.addReceive(1)
      }
      if (actionType === 'addReceive0') {
        this.addReceive(0)
      }
      if (actionType === 'keepDebts') {
        this.keepDebts()
      }
      if (actionType === 'goIncomeCheckout') {
        this.goIncomeCheckout()
      }

      // mint palette 按钮
      if (actionType === 'goScanPay') {
        this.goScanPay()
      }
      if (actionType === 'goIncomeAccount') {
        this.goIncomeAccount()
      }
      if (actionType === 'goInsertBill') {
        this.goInsertBill()
      }
    },

    sub_log() {
      this.$refs.target_1.collapse();
    },
    showDelay() {
      this.sub_log()
      this.$refs.delay.show(this.orderInfo.fMasterDto);
    },
    updateRemark() {
      this.$refs.upRemark.show(this.orderInfo.fMasterDto.masterBase.id, '');
    },
    /*房间信息获取*/
    getrmInfo() {
      this.$http
        .post('/mobilepmsapi/reception/getRoomStatusDetail', this.$route.query)
        .then(res => {
          this.getrmInfoAfter(res);
        });
    },
    getRmType(v) {
      if (this.orderInfo.fMasterDto.codes.rmtype == undefined) {
        return v;
      }
      var value = this.orderInfo.fMasterDto.codes.rmtype[v];
      return value == null ? v : value;
    },
    getrmInfoById(id) {
      this.$http.post('/mobilepmsapi/reception/getRoomStatusDetail', {
        id: id
      }).then(res => {
        this.getrmInfoAfter(res);
      });
    },
    sfzRe(guest) {
      var A = plus.webview.getLaunchWebview();
      var that = this;
      window.sfzback = function (a) {
        var so = JSON.parse(a);
        if (so.error_code != 0) {
          //识别失败！请正面对准身份证，当照片清楚时再拍摄。
          that.msg(this.$t('msg_error_code'));
        } else {
          let guestinfo = [];
          guestinfo.push({
            id: guest.masterBase.id,
            name: so.name,
            idNo: so.id_number,
            idCode: '01',
            address: so.address,
            sex: so.sex,
            birthday: so.birthday,
            national: so.people
          });
          console.log(guestinfo);
          that.$http
            .post('/mobilepmsapi/reception/updateMasterGuest', guestinfo)
            .then(res => {
              if (res.data.result == 0) {
                guest.masterGuest.name = so.name;
                guest.masterGuest.idNo = so.id_number;
                this.msg2(this.$t('msg_update_success'));
              } else {
                this.msg2(res.data.msg);
              }
            });
        }
      };
      A.evalJS('getSFZ(\'' + that.sfzR + '\')');
    },
    getEveryDateRate() {
      this.popupEvalDay = true;
      var mb = this.orderInfo.fMasterDto.masterBase;
      this.$http
        .post('/mobilepmsapi/reception/getEveryDateRate', {
          masterId: mb.id,
          arr: mb.arr,
          dep: mb.dep
        })
        .then(res => {
          this.dateRate = res.data.retVal;
        });
    },
    getrmInfoAfter(res) {
      console.log(res.data.retVal)

      if (res.data.result == 0) {
        this.orderInfo = res.data.retVal;
        // console.log(this.orderInfo);
        this.sfzR = this.orderInfo.fMasterDto.sfzR;
        let rights = this.orderInfo.rights || []
        this.showPayBtn = rights.indexOf('b_sm') > -1; // 根据版本来显示扫码支付按钮
        this.getIfChangeRoom() // 查询是否换过房间
      } else if (res.data.result == 56020) {
        //错误代码返回预订页
        var q = this.$route.query;
        q.isReserve = false;
        this.$router.push({
          path: '/book',
          query: q
        });
      } else {
        this.msg2(res.data.msg);
      }
    },
    goLinkRoom(id) {
      var url = '/fangTXQ?id=' + id;
      if (this.$route.query.redirect != null) {
        url += '&redirect=' + encodeURIComponent(this.$route.query.redirect);
      }
      this.$router.push(url);
      this.getrmInfo();
    },
    /*加收房费*/
    addReceive(value) {
      this.confirm2(
        value == 0 ?
          this.$t('fangTXQ_addReceiveMsg0') :
          this.$t('fangTXQ_addReceiveMsg1'),
        action => {
          this.addReceiveP(value);
        }
      )
    },
    addReceiveP(value) {
      this.$http
        .post('/mobilepmsapi/reception/roomAddCharge', {
          id: this.orderInfo.fMasterDto.masterBase.id,
          type: value,
          cashier: Number(this.currentShift.code)
        })
        .then(res => {
          if (res.data.result == 0) {
            this.getrmInfo();
            this.msg2(this.$t('msg_addReceive_success'));
          } else {
            this.msg2(res.data.msg);
          }
        });
    },

    /*挂账*/
    keepDebts() {
      this.confirm2(this.$t('MessageBox_keepDebts'), action => {
        this.$http
          .post('/mobilepmsapi/reception/roomSuspend', {
            id: this.orderInfo.fMasterDto.masterBase.id,
            suspendTag: 2,
            cashier: Number(this.currentShift.code)
          })
          .then(res => {
            if (res.data.result == 0) {
              this.msg2(this.$t('msg_keepDebts_success'));
              this.getrmInfoById(this.orderInfo.fMasterDto.masterBase.id);
            } else {
              this.msg2(res.data.msg);
            }
          });
      })
    },

    goIncomeCheckout() {
      let orderInfo = this.orderInfo || {}
      let fMasterDto = orderInfo.fMasterDto || {}
      let masterBase = fMasterDto.masterBase || {}
      let coMsg = masterBase.coMsg || ''

      // 版本控制是否支持扫码支付
      let rights = this.orderInfo.rights || []
      let showPayBtn = (rights.indexOf('act!posting') >= 0 && this.showPayBtn) ? 'yes' : 'no'
      this.$router.push('/ftxq/IncomeAccount' + this.formatUrlParam() + '&isCheckout=yes' + '&coMsg=' + coMsg + '&showPayBtn=' + showPayBtn)
    },

    /*办理入住*/
    checkIn() {
      this.confirm2(this.$t('MessageBox_checkIn'), action => {
        this.$http
          .get(
            '/mobilepmsapi/reception/roomCheckIn/' +
            this.orderInfo.fMasterDto.masterBase.id
          )
          .then(res => {
            if (res.data.result == 0) {
              this.checkOutInfo = res.data.retVal;
              this.getrmInfo();
              this.msg2(this.$t('msg_checkin_success'));
            } else {
              this.msg2(res.data.msg);
            }
          });
      })
    },
    cancelOrder() {
      MessageBox.prompt(this.$t('MessageBox_cancelOrder'), '', {
        confirmButtonText: this.$t('MessageBox_confirmButtonText'),
        cancelButtonText: this.$t('MessageBox_cancelButtonText')
      }).then(({value, action}) => {
        this.$http
          .post('/mobilepmsapi/reception/cancelOrder', {
            id: this.orderInfo.fMasterDto.masterBase.id,
            rsvId: this.orderInfo.fMasterDto.masterBase.rsvId, // 新增字段，具体原因问万鹏，大致是因为商务版的缘故
            reason: value
          })
          .then(res => {
            if (res.data.result == 0) {
              this.msg2(this.$t('msg_cancel_success'));
              this.$router.push(this.$route.query.redirect || '/fangT');
            } else {
              this.msg2(res.data.msg);
            }
          });
      })
    },

    sumRate(value) {
      var sum = 0;
      for (var i = 0; i < this.dateRate.length; i++) {
        sum += this.dateRate[i].realShareRate * this.dateRate[i].rmnum;
      }
      return Number.parseFloat(sum).toFixed(2)
    },
    //显示预订支付二维码弹窗
    showQrcodeModal(){
      let _masterId = this.orderInfo.fMasterDto.masterBase.id;
      this.$refs.formQrCodeModal.show(_masterId);
    },
    emitFormQrCode(data){
      this.$refs.qrCodeModal.show({
        ...data,
        name: this.orderInfo.fMasterDto.masterGuest.name,
        arr: this.orderInfo.fMasterDto.masterBase.arr
      });
    }
  },
  filters: {
    dateF(value) {
      return value != '' ? value.replace(/-/g, '/').substring(5, 10) : '';
    },
    dateD(value) {
      return value != '' ? value.replace(/-/g, '/').substring(5, 16) : '';
    },
    dateMD(value) {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('MM/DD');
    },
    week(value) {
      return moment(value).day() == 0
        ? json.week[json.week.length - 1]
        : json.week[moment(value).day() - 1];
    },
  },
  components: {
    jingJiangModal,
    delayIn,
    bill,
    marketInfo,
    updateRemark,
    selectShift,
    signModal,
    qrcodeModal,
    formQrCodeModal
  }
};
</script>

<style lang="less">
.ftxq {
  background-color: #f7f8fa;


  .edit-price-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;

    .edit-price-modal-container {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 5px;
      box-sizing: border-box;
      width: 95%;
      z-index: 1002;

      .edit-price-title {
        font-size: 16px;
        text-align: center;
        padding: 15px 0;
        border-bottom: 1px solid #eaeaea;
        position: relative;

        .iconfont {
          position: absolute;
          top: 15px;
          right: 15px;
          color: #666;
        }
      }

      .edit-top-nav {
        height: 40px;
        line-height: 40px;
        background: #eaeaea;

        .edit-top-item {
          display: inline-block;
          text-align: center;
        }
      }

      .edit-date {
        display: inline-block;
        width: 14%;

        &.firday {
          color: red;
        }
      }

      .origin-price {
        display: inline-block;
        width: 14%;
      }

      .edit-reason {
        display: inline-block;
        width: 36%;
        text-align: center;
      }

      .edit-price {
        display: inline-block;
        width: 32%;
        padding-left: 15px;
        box-sizing: border-box;
        text-align: center;
      }

      .edit-price-body {
        padding: 15px 0;
        box-sizing: border-box;
        min-height: 200px;
        max-height: 400px;
        overflow-y: scroll;

        .edit-price-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px 0;
          color: #666;

          &.active {
            background: #eaeaea;
          }

          select {
            height: 30px;
            line-height: 30px;
            border-radius: 5px;
          }

          .spe-input {
            height: 30px;
            line-height: 30px;
            display: inline-block;
            width: 40px;
            box-sizing: border-box;
            border: 1px solid rgb(169, 169, 169);
            border-radius: 5px;
            box-shadow: none;
            padding-left: 3px;
          }
        }
      }

      .edit-price-footer {
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #eaeaea;

        .edit-price-btn {
          width: 50%;
          text-align: center;
          font-size: 16px;

          &:active {
            background: #eaeaea;
          }

          &.price-cancel-btn {
            border-right: 1px solid #eaeaea;
          }
        }
      }
    }
  }

  .room-list-wrap {
    height: 200px;
    overflow-y: scroll;
    padding: 15px;
    border-top: 1px solid #bdbdbd;

    .room-item {
      display: inline-block;
      min-width: 90px;
      text-align: center;
      border: 1px solid #bdbdbd;
      border-radius: 5px;
      padding: 8px 10px;
      box-sizing: border-box;
      margin-right: 10px;
      margin-bottom: 10px;

      .type-icon {
        display: inline-block;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 3px;
      }

      .rmtype-font {
        color: orangered;
      }

      &.active {
        background: orange;
        color: #fff;
        border: 1px solid orange;

        .rmtype-font {
          color: #fff;
        }
      }
    }
  }

  .print-control {
    border-bottom: 1px solid #fff;
    position: fixed;
    bottom: 45px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #fff;
    background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

    .print-control-btn {
      flex: 1;
      text-align: center;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      box-sizing: border-box;
      height: 45px;
      line-height: 45px;
      color: #fff;
    }
  }

  .door-card-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1111;

    .door-card-container {
      overflow: hidden;
      position: fixed;
      width: 80%;
      background: #fff;
      z-index: 12;
      border-radius: 10px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;

      .door-card-title {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eee;
        text-align: center;
      }

      .door-card-info {
        box-sizing: border-box;
        height: 140px;

        .info-item {
          padding: 10px 15px;
          display: flex;

          .info-item-label {
            color: #333;
            width: 80px;
          }

          .info-item-content {
            color: #666;
          }
        }
      }

      .door-card-bottom {
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #eee;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .door-btns {
          flex: 1;
          text-align: center;
          display: inline-block;
          box-sizing: border-box;
          border-right: 1px solid #eee;

          &:last-child {
            border-right: none;
          }
        }

      }
    }
  }

  .print-select-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1111;

    .modal-container {
      padding: 15px;
      padding-bottom: 0;

      .spe-row {
        display: flex;
        justify-content: space-between;

        .btn-default {
          display: inline-block;
          border: 1px solid #ddd;
          text-align: center;
          font-size: 14px;
          border-radius: 4px;
          padding: 10px 0;
          box-sizing: border-box;
          width: 45%;
          margin-bottom: 15px;

          &:active {
            background: #eee;
          }
        }
      }
    }

    .door-card-container {
      overflow: hidden;
      position: fixed;
      width: 80%;
      background: #fff;
      z-index: 12;
      border-radius: 10px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;

      .door-card-title {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eee;
        text-align: center;
      }

      .door-card-bottom {
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #eee;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .door-btns {
          flex: 1;
          text-align: center;
          display: inline-block;
          box-sizing: border-box;
          border-right: 1px solid #eee;

          &:last-child {
            border-right: none;
          }
        }

      }
    }
  }

  .warp {
    margin: 10px;
    padding-bottom: 180px;

    .orderSta {
      background-color: #f6f8f9;
      height: 29px;
      line-height: 26px;
      color: #333;
      padding: 0 0 3px 0;

      .Num {
        float: left;
        margin-left: 8px;
      }

      .sta {
        float: right;
        margin-right: 8px;

        span {
          color: #ffffff;
          font-weight: bold;
          font-size: 16px;
          border-radius: 12px;
          display: inline-block;
          width: 22px;
          height: 22px;
          text-align: center;
          background: #646f83;
          vertical-align: middle;
          line-height: 22px;
        }
      }
    }

    .infoList {
      padding: 15px 0 15px 0;
      background-color: #fff;
      box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      overflow: hidden;

      .info {
        padding: 0px 0px 15px;
        position: relative;

        .hasChangeIcon {
          position: absolute;
          width: 32px;
          height: 32px;
          border-radius: 32px;
          line-height: 32px;
          text-align: center;
          top: 60px;
          right: 15px;
          border: 2px solid #de7777;
          color: #de7777;
          font-size: 12px;
          font-weight: bold;
          transform: rotate(-30deg);
        }

        .spe-addGuest {
          /*float: right;*/
          position: absolute;
          right: 20px;
          top: 3px;
          background-color: #f6a624;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          text-align: center;

          .iconfont {
            color: #fff;
            font-size: 12px;
            line-height: 20px;
          }
        }

        .infoTop {
          padding: 0 18px;
          position: relative;
          height: 20px;
          line-height: 20px;

          .icon-changfangxingbiaoqian {
            position: absolute;
            font-size: 12px;
            left: 0;
            top: 1px;
            color: #f6a624;
          }

          .addGuest {
            float: right;
            background-color: #f6a624;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            text-align: center;

            .iconfont {
              color: #fff;
              font-size: 12px;
              line-height: 20px;
            }
          }
        }

        .lf {
          clear: both;
          margin-left: 10px;

          li {
            display: inline-block;
            line-height: 20px;
            margin-right: 20px;

            .infoVal {
              margin-left: 8px;
            }
          }

          b {
            color: #fff;
            display: inline-block;
            border-radius: 12px;
            width: 14px;
            height: 14px;
            text-align: center;
            background: #646f83;
            vertical-align: middle;
            line-height: 14px;
          }
        }

        .infoContent {
          margin: 0 20px;
          padding: 10px 0;
          border-bottom: 1px dashed #ddd;

          .btn-add-sm {
            display: inline-block;
            background: #eee;
            font-size: 12px;
            padding: 3px 5px;
          }

          .ha {
            height: auto;
          }

          li {
            line-height: 20px;

            .infoVal {
              margin-left: 8px;

              .icon-xiugai {
                padding: 0.2rem 0.3rem;
                color: #f6a624;
              }
            }

          }

          .p100 {
            clear: both;
            width: 100% !important;
          }

          .mintui-more {
            color: #999;
            margin-left: 10px;
          }

          &.twocol {
            overflow: hidden;

            li {
              width: 50%;
              float: left;
            }
          }
        }

        .checkIn {
          margin: 0 20px;

          li {
            height: 36px;

            .list {
              float: left;
              width: 33.3%;
              text-align: left;
              line-height: 36px;

              .btn {
                height: 24px;
                margin-top: 6px;
                width: 53px;
                background-color: #f6a624;
                float: right;
                text-align: center;
                line-height: 24px;
                border-radius: 2px;
                color: #fff;
              }
            }
          }
        }
      }
    }

    .btnBottom {
      position: absolute;
      left: 0;
      z-index: 100;
      bottom: 0;
      width: 100%;

      .staI {
        text-align: center;
        color: #fff;
        font-size: 16px;
        line-height: 45px;
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

        .btn {
          float: left;
          width: 50%;
          text-align: center;
          color: #fff;
          height: 15px;
          font-size: 15px;
          line-height: 15px;
          margin-top: 15px;
          box-sizing: border-box;
          border-right: 1px solid rgba(255, 255, 255, 0.5);
        }
      }

      .staR {
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

        .btn {
          float: left;
          width: 25%;
          text-align: center;
          color: #fff;
          height: 15px;
          font-size: 15px;
          line-height: 15px;
          margin-top: 15px;
          box-sizing: border-box;
          border-right: 1px solid rgba(255, 255, 255, 0.5);
        }
      }
    }
  }

  .everyDatePop {
    width: 100%;
    height: 50%;
    overflow-y: scroll;

    .checkList {
      width: 100%;
      margin-bottom: 80px;

      tr {
        background-color: #fff;

        &:nth-of-type(2n) {
          background-color: #f5f5f5;
        }

        font-size: 0.32rem;

        th {
          color: #fff;
          height: 1.06666667rem;
          text-align: center;
          font-size: 0.34666667rem;
          background-color: #f69c2c;
          padding: 0;
        }

        td {
          height: 1.06666667rem;
          padding: 0px;
          text-align: center;
        }
      }
    }
  }

  .checkOutPop {
    width: 100%;
    height: 11rem;
    background: #fff; // padding-bottom:35px;
    overflow-y: auto;
    overflow-x: hidden;
    position: fixed;
    bottom: 0;

    .checkList {
      width: 96%;
      height: 40px;
      padding: 5px 10px;
      text-align: left;
      line-height: 40px;
      font-size: 14px;
      position: relative;

      label {
        height: 40px;
        line-height: 40px;
        width: 4rem;
        float: left;
      }

      input {
        box-sizing: border-box;
        padding: 5px;
        float: left;
        height: 30px;
        margin-top: 5px;
        line-height: 25px;
        width: 5rem;
        border-radius: 4px;
        border: 1px solid #e8e8e8;
        -webkit-appearance: none;
        outline: 0;

        &.inv {
          background: #f0f0f0;
        }
      }

      select {
        border: solid 1px #000;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        box-sizing: border-box;
        padding: 2px 5px;
        float: left;
        height: 30px;
        margin-top: 5px;
        line-height: 25px;
        width: 5rem;
        border-radius: 4px;
        background-image: linear-gradient(0deg, #e1e1e1 0%, #f9f9f9 98%);
      }

      select::-ms-expand {
        display: none;
      }

      .iconfont {
        background-color: #686868;
        width: 30px;
        line-height: 30px;
        position: absolute;
        top: 11px;
        text-align: center;
        left: 310px;
        border-radius: 0 5px 5px 0;
        height: 28px;
      }
    }

    .popBottom {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

      .cCancle,
      .cSure {
        float: left;
        height: 100%;
        width: 50%;
        color: #fff;
        font-size: 16px;
        box-sizing: border-box;
        border-right: 2px solid #fff;
        text-align: center;
        line-height: 45px;
      }

      .cSrue {
        border-right: none;
      }
    }
  }

  .dx {
    padding-bottom: 60px;
    text-align: center;
    height: 20px;
    margin-top: 20px;
    line-height: 20px;
    color: #eee;

    span {
      color: #ddd;
    }
  }

  .pb {
    width: 60px;
    height: 60px;
    line-height: 60px;
    color: #fff;
    position: absolute;
    bottom: 120px;
    right: 30px;
  }

  .my-icon-button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f6a624;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  .guestInfo {
    width: 90%;
    height: 330px;
    position: absolute;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 10px 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .guestSwiper {
      padding: 0 4%;

      p {
        font-size: 18px;
        color: #57b658;
        padding: 20px 0 20px 5px;
      }
    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      position: absolute;
      bottom: 0;
      width: 100%;

      .unSure {
        border-right: 1px solid #bdbdbd;
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
      }

      .sure {
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// fangTXQ.vue?58faed2c